'use strict';

(function () {
  var _controller = 'newTurn.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', '$q', 'router.resource', 'reservation.resource', 'additionalInformation.resource',
    'queue.resource', '$timeout', 'holiday.resource', 'reservationStats.resource', 'posTable.resource', 'appRate.modal', 'geolocation.factory', 'reservation.factory',
    'manualGeolocation.modal', 'queueAttending.resource', 'waitingList.resource', 'noTurnsAvailable.modal', 'joinWaitlist.modal', 'image.resource', 'preTurnValidation.resource',
    'professional.resource', 'reservationCalendar.resource'];
  function controller($scope, $q, routerResource, reservationResource, additionalInformationResource,
    queueResource, $timeout, holidayResource, reservationStats, posTableResource, appRateModal, geolocationFactory, reservationFactory,
    manualGeolocationModal, queueAttendingResource, waitingListResource, noTurnsAvailableModal, joinWaitlistModal, imageResource, preTurnValidationResource,
    professionalResource, reservationCalendarResource) {
    //// Methods
    $scope.setStep = async (...args) => { try { await setStep(...args); $scope.$applyAsync(); } catch (error) { $scope.$applyAsync(() => { throw error }); } };
    $scope.nextStep = async (...args) => { try { await nextStep(...args); $scope.$applyAsync(); } catch (error) { $scope.$applyAsync(() => { throw error }); } };
    $scope.nextStepCheck = async (...args) => { try { await nextStepCheck(...args); $scope.$applyAsync(); } catch (error) { $scope.$applyAsync(() => { throw error }); } };
    $scope.prevStep = async (...args) => { try { await prevStep(...args); $scope.$applyAsync(); } catch (error) { $scope.$applyAsync(() => { throw error }); } };
    $scope.selectQueue = async (...args) => { try { await selectQueue(...args); $scope.$applyAsync(); } catch (error) { $scope.$applyAsync(() => { throw error }); } };
    $scope.takeTurn = takeTurn;
    $scope.modifyTurn = modifyTurn;
    $scope.answerQuestion = answerQuestion;
    $scope.finishReservation = finishReservation;
    $scope.getSelectedQueuesNames = getSelectedQueuesNames;
    $scope.limitRoutersOnManualPosition = limitRoutersOnManualPosition;
    $scope.aiCallbacks = {}; // Aqui adentro van los callbacks del componente de informacción adicional, se usa un objeto para evitar peligrosas referencias con $parent
    $scope.dateToAvailability = async (...args) => { try { await dateToAvailability(...args); $scope.$applyAsync(); } catch (error) { $scope.$applyAsync(() => { throw error }); } };
    $scope.joinWaitlist = joinWaitlist;
    $scope.closeNewTurn = closeNewTurn;
    $scope.imageResource = imageResource;
    //// VARS

    if (profile.enterprise && profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig) {
      $scope.hideQueue = profile.enterprise.pwaConfig.turnsConfig.hideQueue;
      var manualRouter = profile.enterprise.pwaConfig.turnsConfig.manualRouter;
    }
    var queryStringRouter = window.queryStrings && window.queryStrings.router;
    var defaultRouter = appNavigator.topPage.data.currentRouter;
    var turnToModify = appNavigator.topPage.data.turnToModify // Para autocompletar los datos de un turno que estoy modificando
    $scope.modifying = false // bandera usada en el jade para saber si estoy modificando el turno
    $scope.autoComplet = false // bandera para saber si tengo que autocompletar los datos cuando estoy modificando
    if (turnToModify && turnToModify.date && !turnToModify.date.getTime) turnToModify.date = new Date(turnToModify.date)
    var allRouters = null; // allRouters contiene todas las sucursales ya filtradas por ubicación si es que estuviera activado el filtro por rango de distancia.
    var queueTree;
    let holidays = holidayResource.query({ _controller: _controller, "applyFor.turns": true }, function (data) { })
    $scope.routers = null; // Estas son las sucursales que el usuario puede elegir, ya filtrada por ubicación y por motivo.
    $scope.allQueues = null; // Estos son los motivos de la sucursal elegida por el usuario.
    $scope.hasMode11 = null;
    $scope.reservation = { inmediate: null };
    $scope.step = null;
    $scope.selectedQueues = []; // Motivos seleccionados . stepMode = 'MULTI-QUEUE-*'.
    $scope.selectedQueue = null; // Motivo seleccionado
    $scope.searchBy = null; // Modo de búsqueda: 'specialty' o 'professionalFirst'
    $scope.selectedProfessional = null; // Profesional seleccionado (MODE11)
    $scope.professionals = null; // Lista de profesionales disponibles (MODE11)
    $scope.selectedRouter = null; // Sucursal seleccionada
    $scope.queueTree = null; // Para armar el arbol de motivos
    $scope.additionalInformation = null; // Si el motivo seleccionado requiere completar informacion adicional
    $scope.availability = null; // Para armar el listado de dias para turnos futuros
    $scope.selectedDate = null; // Fecha actual seleccionada para turno futuro
    $scope.selectedDay = null; // Día actual seleccionado para turno futuro
    $scope.rightNow = null; // Para ocultar cualquier hora que sea anterior a ahora mismo
    $scope.inquiryEnabled = profile.enterprise?.pwaConfig?.turnsConfig?.preTurnInquiry?.enabled || false;
    $scope.finishedInquiry = $scope.inquiryEnabled ? false : true; // Si esta habilitada la encuesta previa, entonces no está respondida en este momento
    $scope.stepMode = profile.enterprise && profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig && profile.enterprise.pwaConfig.turnsConfig.stepMode || null;
    var onClose = appNavigator.topPage.data && appNavigator.topPage.data.onClose;
    var reservationConfig = null; // Configuración de turnos del reouter
    var posTables = null; // En caso que el modo sea calendarizado por locación
    var routerReservations = null; // Para el calculo de disponibilidad
    var additionalInformations = null;
    var steps = ['router', 'searchBy', 'professionalFirst', 'queue', 'professional', 'slots', 'reservationType', 'day', 'date', 'additional', 'comment', 'confirm'];

    $scope.AttachedImgFilesConfig = { multiple: true, accept: "'image/*'", maxSize: '10MB', capture: "'camera'" };
    $scope.AttachedAllFilesConfig = { multiple: true, maxSize: '10MB', capture: "'camera'" };

    var additionalInformationProfile = $scope.$root.profile && $scope.$root.profile.enterprise && $scope.$root.profile.enterprise.additionalInformation || [];
    $scope.maxRouterDistance = profile.enterprise && profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig && profile.enterprise.pwaConfig.turnsConfig.maxRouterDistance
    $scope.routersReady = false
    $scope.outOfRange = false
    $scope.userPosition;
    $scope.availablesDays = null
    var notAttending = false
    $scope.myWaitingList = [] // Array que contiene mi lista de espera
    $scope.visibleQueueTree = null;
    $scope.searchTerm = '';
    // Init
    init()

    // WATCHERS
    $scope.$on('$destroy', onDestroy)
    $scope.$watch('queues.length', (newVal, oldVal) => {
      if (newVal === oldVal) return
      if ($scope.queues && $scope.queues.some(f => f.activeWaitingList))
        getMyWaitingList()
    })
    // Scroll cuando se agrega una nueva pregunta
    $scope.$watch('questionsBreadcrumb.length', function (newVal, oldVal) {
      if (newVal > oldVal && !$scope.failed) {
        $timeout(function () {
          var container = document.querySelector('.res-process');
          var last = container?.querySelector('.last-question');
          last?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    });

    $scope.$watch('searchTerm', function (newVal) {
      nodeMatchesSearch(newVal);
    });

    // Scroll final
    $scope.$watch('failed', function (newVal) {
      if (newVal) {
        $timeout(function () {
          var container = document.querySelector('.res-process');
          var failedEl = container?.querySelector('.failed-message-container');
          failedEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    });
    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    // Implementación
    async function init() {
      try {
        const result = await routerResource.query({ _controller: _controller }).$promise;
        allRouters = result.filter(function (f) { return !f.hidden });
        $scope.unfilteredRouters = allRouters // unfilteredRouters se usa para obtener todos los routers a la hora de filtrarlos manualmente (una vez que el filtro automático falló).
        additionalInformations = additionalInformationResource.query({ targets: 'QUEUE', moments: 'PRE', _controller: _controller });
        const results = await $q.all([filterRoutersByDistance(allRouters), additionalInformations.$promise]);
        allRouters = results[0];
        $scope.routers = allRouters;
        $scope.routersReady = true
        $scope.routersDistanceReady = true;
        if ($scope.maxRouterDistance && !allRouters.length) {
          $scope.outOfRange = true
          if (!$scope.userPosition) $scope.humanizedPosition = false
          else {
                displayLocation($scope.userPosition.latitude, $scope.userPosition.longitude).then(function (humanizedPosition) {
                  $scope.humanizedPosition = humanizedPosition
                }).catch(function (err) { throw new PentaError(err) })
          }
        }
        if (turnToModify) {
          $scope.modifying = true
          $scope.autoComplet = true
          $scope.reservation = angular.copy(turnToModify)
          delete $scope.reservation._id
        }
        switch ($scope.stepMode) {
          case 'MULTI-QUEUE-FIRST':
            steps.unshift('multiQueueFirst');
            const data = await queueResource.query({ enterprise: profile.enterprise._id, _controller: _controller }).$promise;
            //voy a filtrar todos los motivos que sean pagos, no está implementado motivos pagos para multi turnos
            const filteredData = data.filter(f => f.routers && !f.routers.find(r => r.payConfig && r.payConfig.enabled))
            filteredData.forEach(function (item) { buildChilds(item, filteredData) });
            queueTree = filteredData.filter(function (f) { return !f.parent });
            $scope.queueTree = queueTree;
            $scope.visibleQueueTree = $scope.queueTree;
            $scope.searchTerm = '';
            $scope.step = steps[0];
            if ($scope.autoComplet) {
              if (turnToModify._childrens.length)
                for (const item of turnToModify._childrens) {
                  var queue = filteredData.find(function (f) { if (f._id === item.queue) { return f } })
                  if (queue) await selectQueue(queue)
                }
              else {
                var queue = filteredData.find(function (f) { if (f._id === turnToModify.queue) { return f } })
                if (queue) await selectQueue(queue)
              }
              await nextStep(true);
            }
            else if (filteredData.length === 1) {
              await nextStep(filteredData[0]);
            }
            break;
          default:
            $scope.step = steps[0];
            initializeInquiry();
            if ($scope.autoComplet) {
              await nextStep(turnToModify.router);
            }
            else if ((!manualRouter || queryStringRouter) && !$scope.inquiryEnabled) {
              if ($scope.routers.find(function (f) { return f._id === defaultRouter._id })) {
                await nextStep(defaultRouter._id); // Elijo por defecto el router si es necesario.
              }
            }
            break;
        }
        $scope.$applyAsync();
      } catch (err) {
        $scope.$applyAsync(() => { throw err });
      }
    }

    async function setStep(stepName) {
      $scope.step = stepName;
      // Reseteo los pasos posteriores
      for (var stepIx = steps.indexOf(stepName) + 1; stepIx < steps.length; stepIx++) {
        await nextStep(null, steps[stepIx]);
      }
      // Reseteo turnsToModify porq si cambia de step ya no tengo q autocompletar los datos
      $scope.autoComplet = false;
    }

    // solo se usa en el caso stepValue = INMEDIATE
    async function nextStepCheck(stepValue) {
      notAttending = false
      if (stepValue !== 'INMEDIATE') return
      if ($scope.selectedQueue.router && $scope.selectedQueue.router.immediateOnlyIfAttending) {
        const data = await queueAttendingResource.get({
          enterprise: profile.enterprise._id,
          router: $scope.selectedRouter._id,
          queue: $scope.selectedQueue._id,
          _controller: _controller
        }).$promise;
        notAttending = data.notAttending
        if (notAttending) {
          $scope.disableInmediaTurns = true
          ons.notification.alert({ message: i18next.t('No hay agentes para atender en forma inmediata, agende un turno '), title: i18next.t('Atención') });
          await setStep('reservationType')
        } else {
          await nextStep(stepValue);
        }
      } else {
        await nextStep(stepValue);
      }
    }

    // Función para validar pre-turno cuando el usuario selecciona un motivo
    async function validatePreTurnOnQueueSelection(queue) {
      try {
        if (!$scope.selectedRouter || !queue) {
          return { allowed: true };
        }

        var validationData = {
          router: $scope.selectedRouter._id,
          queue: queue._id,
          name: $scope.$root.profile.name,
          email: $scope.$root.profile.email,
          telephone: $scope.$root.profile.telephone || $scope.$root.profile.telephoneNumber,
          identificationType: $scope.$root.profile.identificationType,
          identificationNumber: $scope.$root.profile.identificationNumber
        };
        const result = await preTurnValidationResource.validate(validationData).$promise;
        return result;
      } catch (error) {
        console.error('Error en validación pre-turno:', error);
        // En caso de error, permitir continuar por defecto
        return { allowed: true };
      }
    }

    // Función para mostrar notificaciones de validación fallida
    function showValidationFailedNotification(validationResult) {
      if (validationResult.redirectUrl) {
        ons.notification.confirm({
          message: validationResult.message || i18next.t('No se puede procesar la solicitud. ¿Desea ir al enlace para completar el proceso?'),
          title: i18next.t('Validación requerida'),
          buttonLabels: [i18next.t('Cerrar'), validationResult.redirectButtonText || i18next.t('Ir al enlace')]
        }).then(function (buttonIndex) {
          if (buttonIndex === 1) {
            window.open(validationResult.redirectUrl, '_blank');
          }
        });
      } else {
        ons.notification.alert({
          message: validationResult.message || i18next.t('No se puede procesar la solicitud en este momento'),
          title: i18next.t('No se puede continuar')
        });
      }
    }

    async function nextStep(stepValue, stepName) {
      // Procesar el valor actual
      var step = stepName || $scope.step;
      switch (step) {
        case 'router':
          $scope.hasMode11 = null; // Resetear al cambiar de sucursal para que se vuelva a calcular
          if (stepValue) {
            $scope.selectedRouter = $scope.routers.find(function (f) { return f._id === stepValue });
            if (!$scope.selectedRouter) throw new PentaError('Sucursal inválida')
            $scope.routerStats = reservationStats.get({ router: stepValue });
            $scope.reservation.router = stepValue;
            $scope.selectedQueues.forEach(function (queue) { queue.router = queue.routers && queue.routers.length && queue.routers.find(function (f) { return f._id === $scope.reservation.router }); })
            //$scope.queueTree = null;
          } else {
            $scope.selectedRouter = null;
            $scope.reservation.router = null;
          }
          break;
        case 'searchBy':
          $scope.searchBy = stepValue || null;
          $scope.searchBySelected = stepValue || '';
          break;
        case 'professionalFirst':
          if (stepValue) {
            $scope.selectedProfessional = stepValue;
            $scope.reservation.calendarUser = stepValue._id;
          } else {
            $scope.selectedProfessional = null;
            $scope.reservation.calendarUser = null;
          }
          break;
        case 'queue':
          if ($scope.reservation.calendarUser && $scope.reservation?.queue && $scope.reservation.queue !== stepValue?._id) {
            // limpiar profesional si se cambia el motivo
            $scope.selectedProfessional = null;
            $scope.reservation.calendarUser = null;
          }
          if (!stepValue) {
            $scope.selectedQueue = null;
            $scope.reservation.queue = null;
            $scope.queues = null;
            $scope.queueTree = null;
          } else if ($scope.stepMode !== 'MULTI-QUEUE-FIRST') {
            // Validar pre-turno antes de continuar
            const validationResult = await validatePreTurnOnQueueSelection(stepValue);
            if (!validationResult.allowed) {
              showValidationFailedNotification(validationResult);
              return;
            } else if (validationResult.errorMessage) {
              $scope.reservation.webhookData = { error: validationResult.errorMessage };
            }
            $scope.selectedQueue = stepValue;
            $scope.reservation.queue = stepValue && stepValue._id;
            $scope.reservation._payment = stepValue.router && stepValue.router.payConfig && stepValue.router.payConfig.enabled
            // Exponer el gateway del router para que el jade pueda mostrar el botón correcto
            $scope.reservation._paymentGateway = $scope.selectedRouter && $scope.selectedRouter.paymentGateway || 'MERCADOPAGO-AR';

            notAttending = false
            if ($scope.selectedQueue.router && $scope.selectedQueue.router.immediateOnlyIfAttending)
              queueAttendingResource.get({ enterprise: profile.enterprise._id, router: $scope.selectedRouter._id, queue: $scope.selectedQueue._id, _controller: _controller }, function (data) {
                notAttending = data.notAttending
              })
          }
          // consultar las mesas si el modo es calendarizado por locación (Cuando este en multimotivo no va andar esta deteccion!!!!)
          if (stepValue && reservationFactory.isMode567($scope.selectedQueue, $scope.selectedQueues))
            posTables = posTableResource.query({ router: $scope.selectedRouter._id, _controller: _controller });
          break;
        case 'professional':
          if (stepValue) {
            $scope.selectedProfessional = stepValue;
            $scope.reservation.calendarUser = stepValue._id;
          } else if ($scope.searchBy !== 'professionalFirst') {
            $scope.selectedProfessional = null;
            $scope.reservation.calendarUser = null;
          }
          break;
        case 'slots':
          if (stepValue) $scope.reservation.slots = stepValue;
          else $scope.askForSlots = false;
          break;
        case 'additional':
          if (stepValue) {
            $scope.reservation.additionalInformation = [];
            //var additionalInformationBackUp = getAdditionalInformationBackup();
            $scope.additionalInformation.forEach(function (f) {
              if (f.type === 'CLIENT-IDENTIFICATION-NUMBER') {
                $scope.reservation.identificationNumber = f.value;
                $scope.reservation.identificationType = f.identificationType;
              }
              else if (f.type === 'CLIENT-TELEPHONE') $scope.reservation.telephone = f.value;
              else if (f.type === 'CLIENT-ADDRESS') $scope.reservation.address = f.value;
              //additionalInformationBackUp[f._id] = f.value;
            })
            //appStorage.set("additionalInformationBackUp", JSON.stringify(additionalInformationBackUp));
          } else $scope.reservation.additionalInformation = null;
          break;
        case 'reservationType':
          var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
          if (stepValue && !validateReservationType(stepValue, routerReservations, queues))
            return ons.notification.alert({ message: i18next.t('No se puede solicitar mas turnos ') + (stepValue === 'INMEDIATE' ? i18next.t('inmediatos') : i18next.t('futuros')), title: i18next.t('Atención') });
          if (stepValue === 'INMEDIATE') {
            $scope.reservation.inmediate = true;
          } else if (stepValue === 'FUTURE') {
            $scope.reservation.inmediate = false;
          } else {
            $scope.reservation.inmediate = null;
          }
          break;
        case 'day':
          if (stepValue && stepValue.isFullDay) $scope.reservation.waitingListDate = stepValue && stepValue.date
          $scope.selectedDay = stepValue;
          break;
        case 'date':
          if (!stepValue) $scope.selectedDate = null; // Se usa para que cuando se accede a este paso directamente, se vacie el valor y el usuario pueda volver a elegir el que quiera.
          $scope.reservation.date = stepValue && stepValue.start;
          $scope.reservation.posTable = stepValue && stepValue.posTable;
          break;
        case 'comment':
          $scope.reservation.comment = stepValue;
          break;
      }
      if (stepName) return;
      // Avanzar un paso
      var stepIx = steps.indexOf($scope.step);
      stepIx++;
      $scope.step = steps[stepIx];
      // Inicializar el paso
      switch ($scope.step) {
        case 'router':
          if ($scope.selectedQueues.length) {
            routersAvailableForQueues();
          }
          if ($scope.autoComplet) {
            await nextStep(turnToModify.router)
          }
          break;
        case 'searchBy':
          $scope.searchBySelected = '';
          if ($scope.stepMode === 'MULTI-QUEUE-FIRST' || $scope.autoComplet) {
            await nextStep('specialty');
          } else {
            // Consultar motivos para ver si hay alguno modo 11 en esta sucursal
            $scope.allQueues = await queueResource.query({ router: $scope.reservation.router, _controller: _controller }).$promise;
            $scope.hasMode11 = $scope.allQueues.some(q => reservationFactory.isMode11(q, $scope.selectedRouter));
            // Si no hay motivos de modo 11, no muestra selector especialidad/profesional, salta directamente a selector de motivos
            if (!$scope.hasMode11) await nextStep('queue');
          }
          break;
        case 'professionalFirst':
          if ($scope.searchBy === 'professionalFirst') {
            // Cargar todos los profesionales de la sucursal (sin filtrar por motivo)
            $scope.professionals = await professionalResource.query({
              router: $scope.reservation.router,
              _controller: _controller
            }).$promise;
            if ($scope.professionals.length === 1) {
              await nextStep($scope.professionals[0]);
            }
          } else {
            await nextStep(); // Saltar si el usuario eligió por especialidad
          }
          break;
        case 'queue':
          //- Esta bandera es para turnos inmediatos con fecha especial. Feature para solicitar el proximo turno inmediato disponible
          $scope.specialImmediateDate = false;
          if (!$scope.selectedQueues.length) {
            let data = $scope.allQueues || await queueResource.query({ router: $scope.reservation.router, _controller: _controller }).$promise;
            if ($scope.hasMode11) {
              data = await filterQueuesByValidCalendars(data, $scope.selectedProfessional); // Si es modo 11 va a filtrar aquellos motivos que tengan calendario
            }
            $scope.queues = data.filter(function (f) { return f.router.target && !f.router.target.pwaChat });
            // Si el usuario eligió por profesional, filtrar los motivos asignados a ese profesional
            data.forEach(function (item) {
              item._routerPrice = (item.router && item.router.payConfig && item.router.payConfig.enabled) ? item.router.payConfig.price : null
              buildChilds(item, data)
            });
            $scope.queueTree = $scope.queues.filter(function (f) { return !f.parent });
            $scope.visibleQueueTree = $scope.queueTree;
            $scope.searchTerm = '';
            //Si estoy modificando el turno completo los datos y sigo al siguiente paso
            if ($scope.autoComplet) {
              var selectedQueue = $scope.queues.find(function (f) { return f._id === turnToModify.queue })
              if (selectedQueue) {
                await nextStep(selectedQueue);
              }
            }
            else if ($scope.queues.length === 1) {
              await nextStep($scope.queues[0]);
            }
          } else {
            await nextStep();
          }
          break;
        case 'professional':
          if ($scope.searchBy === 'professionalFirst' && $scope.selectedProfessional) {
            // El profesional ya fue elegido en professionalFirst, saltar este paso
            await nextStep();
          } else if (!reservationFactory.isMode11($scope.selectedQueue, $scope.selectedRouter)) {
            // Si no es MODE11, saltar este paso
            await nextStep();
          } else {
            $scope.professionals = await professionalResource.query({
              router: $scope.reservation.router,
              queue: $scope.reservation.queue,
              _controller: _controller
            }).$promise;
            if ($scope.professionals.length === 1) {
              await nextStep($scope.professionals[0]);
            }
          }
          break;
        case 'slots':
          var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
          var minAskForSlots = Math.min.apply(null, queues.map(function (m) { return m.askForSlots || 0; }))
          if ($scope.autoComplet) {
            await nextStep(turnToModify.slots);
          }
          else {
            if (minAskForSlots) {
              $scope.askForSlots = true;
              $scope.maxSlots = [];
              for (var i = 1; i <= minAskForSlots; i++) $scope.maxSlots.push(i);
            } else {
              await nextStep(1); // Si no requiere cantidad de personas se setea en 1
            }
          }
          break;
        case 'additional':
          var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
          $scope.additionalInformation = additionalInformations.filter(function (ai) {
            if (!ai.queues || !ai.queues.length) return true;
            return ai.queues.find(function (f) { return queues.find(function (queue) { return queue._id === f }); })
          })
          if (!$scope.additionalInformation || !$scope.additionalInformation.length) {
            await nextStep(false);
          }
          $scope.additionalInformation.forEach(function (f) { setAdditionalInformationFromProfile(f); });
          //applyAdditionalInformationBackUp($scope.additionalInformation);
          break;
        case 'reservationType':
          const routerData = await routerResource.get({ _id: $scope.reservation.router, _controller: _controller }).$promise;
          $scope.selectedRouter.reservationConfig = routerData.reservationConfig;
          const maxDays = $scope.selectedRouter.reservationConfig.extendAvailabilityDays ? 90 : 45;
          const reservationData = await reservationResource.query({
            router: $scope.reservation.router,
            maxDate: moment().set({ hours: 23, minutes: 59, seconds: 59, milliseconds: 999 }).add(maxDays, 'days').toDate(),
            _controller: _controller
          }).$promise;
          routerReservations = reservationData;
          $scope.rightNow = new Date();
          if (turnToModify) {
            // si estoy modificando turno solo contabilizo las reservas que no estoy modificando (para que se calcule bien la disponibilidad)
            routerReservations = routerReservations.filter(function (f) {
              if (f._id !== turnToModify._id && !turnToModify._childrens.find(function (c) { return c._id === f._id })) return true
            })
          }
          const mainQueue = $scope.selectedQueue || $scope.selectedQueues[0]
          let reservationCalendars = [];
          if (reservationFactory.isMode11(mainQueue, $scope.selectedRouter) && $scope.reservation.calendarUser) {
            reservationCalendars = await reservationCalendarResource.query({
              router: $scope.reservation.router,
              userCredential: $scope.reservation.calendarUser,
              _controller: _controller
            }).$promise;
          }
          $scope.availability = reservationFactory.calculateAvailability({
            router: $scope.selectedRouter,
            mainQueue: mainQueue,
            queues: $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues,
            slots: $scope.reservation.slots || 1,
            currentReservations: routerReservations,
            holidays: holidays,
            posTables: posTables,
            maxDays: maxDays,
            //- Este true es importante para que la function canInmediate funcione correctamente,
            //- No se debe quitar ni hacer condicional!!
            includeFullDays: true,
            reservationCalendars: reservationCalendars,
            calendarUser: $scope.reservation.calendarUser,
          });
          $scope.availablesDays = $scope.availability.filter(f => !f.isFullDay).map(function (m) { return changeUTC(m.date, $scope.selectedRouter.utcOffset, moment().format('Z').replace(':', '')) })
          $scope.fullDays = mainQueue.activeWaitingList ? $scope.availability.filter(f => f.isFullDay).map(function (m) { return changeUTC(m.date, $scope.selectedRouter.utcOffset, moment().format('Z').replace(':', '')) }) : []

          // ESTO DEBERIA SER MAS INTELIGENTE y verificar ambas queue.
          var queue = $scope.selectedQueue || $scope.selectedQueues[0];
          $scope.disableInmediaTurns = queue.disableInmediaTurns || notAttending;
          $scope.disableFutureTurns = queue.disableFutureTurns;
          // POR EL MOMENTO NO SE SOPORTA SACAR TURNOS INMEDIATOS PARA EL MULTI TURNO.
          if ($scope.selectedQueues.length) $scope.disableInmediaTurns = true;
          if ($scope.autoComplet) {
            await nextStep(turnToModify.inmediate ? "INMEDIATE" : "FUTURE");
          }
          else {
            if ($scope.disableInmediaTurns) {
              await nextStep('FUTURE');
            }
            else if ($scope.disableFutureTurns) {
              await nextStep('INMEDIATE');
            }
          }
          break;
        case 'day':
          if ($scope.autoComplet) {
            if (turnToModify.date) {
              var selectedDay = $scope.availability.find(function (f) {
                if (f.date.getDay() === turnToModify.date.getDay() && f.date.getMonth() === turnToModify.date.getMonth() && f.date.getYear() === turnToModify.date.getYear())
                  return f
              })
              if (selectedDay) {
                await nextStep(selectedDay);
              }
            }
          }
          else if ($scope.reservation.inmediate) {
            const { isCanInmediate, errorTitle, errorMessage } = canInmediate($scope.availability, $scope.reservation, $scope.selectedRouter)
            if (!isCanInmediate) {
              await ons.notification.alert({ title: errorTitle, message: errorMessage })
              delete $scope.reservation.inmediate
              delete $scope.reservation.date
              await setStep('queue')
            } else {
              await nextStep($scope.availability[0]);
            }

          }
          break;
        case 'date':
          if ($scope.autoComplet) {
            if (turnToModify.date) {
              var selectedHour = $scope.selectedDay.hours.find(function (f) {
                if (f.start.getHours() === turnToModify.date.getHours() && f.start.getMinutes() === turnToModify.date.getMinutes())
                  return f
              })
              if (selectedHour) {
                await nextStep(selectedHour);
              }
            }
          }
          else if ($scope.reservation.inmediate) {
            await nextStep($scope.availability[0].hours[0]);
          }
          break;
        case 'comment':
          if (profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig && profile.enterprise.pwaConfig.turnsConfig.hideComment) {
            await nextStep('');
          }
          break;
      }
    }

    async function prevStep() {
      // Step order: 'router', 'searchBy', 'professionalFirst', 'queue', 'professional', 'slots', 'reservationType', 'day', 'date', 'additional', 'comment', 'confirm'
      switch ($scope.step) {
        case 'queue':
          if (!$scope.hasMode11) await setStep('router') // Si no tiene motivos modo 11, entonces redirige al selector de sucursal
          else await setStep('searchBy')
          break;
        case 'slots':
          if (!$scope.hasMode11) await setStep('queue') // redirige al selector de motivos ya que los profesionales no tienen slots
          break;
        case 'reservationType':
          if ($scope.askForSlots) await setStep('slots')
          else if ($scope.selectedProfessional && $scope.searchBy !== 'professionalFirst') await setStep('professional')
          else await setStep('queue')
          break;
        case 'date':
          $scope.selectedDate = null;
          await setStep('day')
          break;
        case 'additional':
          if ($scope.reservation.inmediate) await setStep('reservationType')
          else await setStep('date')
          break;
        case 'comment':
          if ($scope.additionalInformation && $scope.additionalInformation.length) await setStep('additional')
          else if (!$scope.reservation.inmediate) await setStep('date')
          else await setStep('reservationType')
          break;
        default:
          var stepIndex = steps.indexOf($scope.step)
          if (stepIndex === 0 || (stepIndex === 1 && profile.enterprise.pwaConfig.turnsConfig.blockBranchChange)) return appNavigator.popPage()
          await setStep(steps[stepIndex - 1])
          break;
      }
    }

    function initializeInquiry() {
      if (!$scope.inquiryEnabled) return
      $scope.questions = angular.copy(profile.enterprise?.pwaConfig?.turnsConfig?.preTurnInquiry?.questions);
      if (!$scope.questions?.length) return

      $scope.failed = false;
      $scope.closeMessage = '';

      $scope.questionsBreadcrumb = [$scope.questions[0]] // Inicializo con la primera pregunta
    }

    function answerQuestion(question, answer, questionIndex) {
      // Si el usuario cambia una respuesta previa, restablecemos desde ahí
      if (questionIndex < $scope.questionsBreadcrumb.length - 1) {
        // Antes de recortar, limpiar respuestas seleccionadas en las preguntas que se eliminan
        $scope.questionsBreadcrumb.slice(questionIndex + 1).forEach(q => {
          q.answers.forEach(ans => ans._selected = false);
        });

        $scope.questionsBreadcrumb = $scope.questionsBreadcrumb.slice(0, questionIndex + 1);
      }

      // Marcar respuesta seleccionada
      question.answers.forEach(ans => ans._selected = false);
      answer._selected = true;

      // Evaluar qué hacer con la respuesta
      if (answer.redirectTo === 'CLOSE-MESSAGE') {
        showCloseMessage(question)
        $scope.failed = true;
        return;
      }
      if (answer.redirectTo === 'END-INQUIRY') {
        $scope.finishedInquiry = true;
        if (!manualRouter || queryStringRouter) nextStep(defaultRouter._id);
        return;
      }

      // Buscar la siguiente pregunta si existe
      const nextQuestion = $scope.questions.find(q => q._id === answer.redirectTo);
      if (nextQuestion) {
        $scope.failed = false;
        $scope.questionsBreadcrumb.push(nextQuestion);
      }
    };

    function showCloseMessage(question) {
      $scope.closeMessage = linkify(question.closeMessage);
      $scope.failed = true;

      const closeElement = document.getElementById('closeMessage');
      if (closeElement) {
        closeElement.style.backgroundColor = question.closeMessageBg || 'white';
        closeElement.style.color = question.closeMessageText || 'black';
      }
    }

    function closeNewTurn() {
      appNavigator.popPage();
    }

    function linkify(text) {
      if (!text) return "";
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const linkedText = text.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
      return linkedText;
    }

    async function filterQueuesByValidCalendars(queues, selectedProfessional) {
      const calendars = await reservationCalendarResource.query({ router: $scope.reservation.router, type: 'AVAILABILITY', _controller: _controller }).$promise;
      return selectedProfessional
        ? filterQueuesForProfessional(queues, calendars, selectedProfessional)
        : filterQueuesForSpecialty(queues, calendars);
    }

    // Sin profesional: elimina motivos MODE11 sin ningún calendario de disponibilidad. No-MODE11 pasan siempre.
    function filterQueuesForSpecialty(queues, calendars) {
      if (calendars.some(cal => cal.allQueues)) return queues;
      const calendarQueueIds = buildCalendarQueueIds(calendars);
      const leafTest = q => !reservationFactory.isMode11(q, $scope.selectedRouter) || calendarQueueIds.has(q._id);
      return reservationFactory.filterQueuesByLeafTest(queues, leafTest);
    }

    // Con profesional: muestra solo los motivos MODE11 del profesional, sin passthrough para no-MODE11.
    function filterQueuesForProfessional(queues, calendars, professional) {
      const profCalendars = calendars.filter(cal => cal.userCredential === professional._id);
      if (profCalendars.some(cal => cal.allQueues)) return queues.filter(q => reservationFactory.isMode11(q, $scope.selectedRouter));
      const calendarQueueIds = buildCalendarQueueIds(profCalendars);
      const leafTest = q => calendarQueueIds.has(q._id);
      return reservationFactory.filterQueuesByLeafTest(queues, leafTest);
    }

    // Construye el conjunto de IDs de motivos cubiertos por al menos un calendario.
    function buildCalendarQueueIds(calendars) {
      return new Set(calendars.flatMap(cal => cal.queues || []));
    }

    function buildChilds(parent, nodes) {
      if (typeof parent.nodes === 'undefined') Object.defineProperty(parent, 'nodes', { writable: true });
      parent.nodes = nodes.filter(function (f) { return f.parent === parent._id });
      parent.nodes.forEach(function (node) {
        node._parentArray = parent.nodes;
      })
      parent.nodes.forEach(function (item) { buildChilds(item, nodes) });
    }

    async function selectQueue(queue) {
      if (!queue) return
      if (!queue.nodes.length) {
        switch ($scope.stepMode) {
          case 'MULTI-QUEUE-FIRST':
            queue._selected = !queue._selected;
            if (queue._selected) $scope.selectedQueues.push(queue);
            else {
              var index = $scope.selectedQueues.findIndex(function (f) { return f._id === queue._id });
              if (index != -1) $scope.selectedQueues.splice(index, 1);
            }
            break;
          default:
            clearSelectedParents()
            queue._selected = true;
            return await nextStep(queue);
        }
      }
      else {
        if (!queue._hide) queue._hide = true;
        else queue._hide = false;
      }
      return queue
    }

    function clearSelectedParents(nextParents) {
      var queues = nextParents || $scope.queues;
      queues.forEach(function (f) {
        if (f._selected === true) f._selected = false;
        if (!f.parent && f.parent !== f._id) f._hide = false;
        if (f.nodes && f.nodes.length) clearSelectedNodes(f.nodes)
      })
    }

    function clearSelectedNodes(nextNodes) {
      nextNodes.forEach(function (f) {
        if (f._selected === true) f._selected = false;
        if (f.nodes && f.nodes.length) clearSelectedParents(f.nodes)
      })
    }

    function modifyTurn() {
        var promesas = []
        if (turnToModify._childrens.length)
          turnToModify._childrens.forEach(function (item) {
            promesas.push(cancelReservation(item, true, true))
          })
        else
          promesas.push(cancelReservation(turnToModify, true, true))

      $q.all(promesas).then(function () {
        takeTurn()
      }).catch(function (err) { return new PentaError(err) })
    }

    function cancelReservation(turn, dontSendCancelEmail, cancelDueModify) {
      return reservationResource.cancelReservation({ _id: turn._id, dontSendCancelEmail: dontSendCancelEmail || false, cancelDueModify: cancelDueModify, _controller: _controller }, function () { }).$promise
    }

    async function takeTurn() {
      try {
        var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
        $scope.reservation.email = $scope.$root.profile.email;
        $scope.reservation.extraData = {};
        $scope.reservation.extraData.externalId = $scope.currentRouter.externalId;
        $scope.reservation.extraData.ticketNow = $scope.reservation.inmediate;
        //TO-DO si estoy modificando un turno tengo que cancelar el mismo y despues crear el nuevo

        // Esto permite al componente de información adicional persistir la información en el perfil del cliente
        if (typeof $scope.aiCallbacks.persistInProfile === 'function') $scope.aiCallbacks.persistInProfile();
        // Esto permite al componente de información adicional encriptar información entre otras cosas
        if (typeof $scope.aiCallbacks.additionalInformationPreSave === 'function') $scope.aiCallbacks.additionalInformationPreSave();
        let turnsConfig = profile.enterprise && profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig;
        let err = await reservationFactory.takeTurn(queues, routerReservations, $scope.reservation, $scope.additionalInformation, turnsConfig)
        if (err && err.message === '7005') return await setStep('router');
        // persistInProfile es una funcion que entrega el componente de información adicional, pueden encontrarlo en additionalInformation.subview.jade
        finishReservation();
        /////
        $scope.$applyAsync();
      }
      catch (err) {
        $scope.$applyAsync(() => { throw err });
      }
    }

    async function joinWaitlist() {
      try {
        if (!$scope.reservation) throw new PentaError('No se puede operar sin una reserva')
        if (!$scope.reservation.waitingListDate || !($scope.reservation.waitingListDate instanceof Date))
          throw new PentaError('La fecha ingresada no es un formato valido')
        if (!$scope.reservation.router) throw new PentaError('No se puede operar sin una Sucursal')
        if (!$scope.reservation.queue) throw new PentaError('No se puede operar sin un Motivo')
        let body = {
          router: $scope.reservation.router,
          queue: $scope.reservation.queue,
          date: moment($scope.reservation.waitingListDate).utcOffset("0000", true).startOf('day'),
          comment: $scope.reservation.waitingListComment
        }
        let waitingList = await waitingListResource.save(body).$promise
        joinWaitlistModal.open({ waitingList: waitingList })
          .then(function () { finishReservation(true) })
          .catch(function (error) { console.log(error); finishReservation(true) })
        $scope.$applyAsync();
      }
      catch (err) { $scope.$applyAsync(() => { throw err }); }
    }

    function finishReservation(dontOpenRateModal) {
      onClose();
      appNavigator.popPage()
      $timeout(function () {
        if (!dontOpenRateModal) appRateModal.open('newTurn')
      }, 7000)
    }

    function validateReservationType(stepValue, myReservations, queues) {
      if (!myReservations || !myReservations.length) return true;
      return queues.every(function (queue) {
        var count = 0;
        if (stepValue === 'INMEDIATE') {
          if (!queue.maxInmediaTurnsPerUser) return true;
          count = myReservations.reduce(function (total, current) {
            if (current.client && current.inmediate && (current.queue === queue._id)) total += 1;
            return total;
          }, 0)
          if (count < queue.maxInmediaTurnsPerUser) return true;
        }
        if (stepValue === 'FUTURE') {
          if (!queue.maxFutureTurnsPerUser) return true;
          count = myReservations.reduce(function (total, current) {
            if (current.client && !current.inmediate && (current.queue === queue._id)) total += 1
            return total;
          }, 0)
          if (count < queue.maxFutureTurnsPerUser) return true;
        }
        return false;
      })
    }

    function getSelectedQueuesNames() {
      var text = '';
      if (!$scope.selectedQueues.length) return '';
      $scope.selectedQueues.forEach(function (f, i) {
        if (f.name) text += f.name + ($scope.selectedQueues.length > 1 && $scope.selectedQueues.length !== (i + 1) ? ', ' : '');
      })
      return text
    }

    function routersAvailableForQueues() {
      $scope.routers = allRouters;
      $scope.routers = $scope.routers.filter(function (router) {
        return $scope.selectedQueues.every(function (f) { return f.routers.find(function (r) { return r._id === router._id }) });
      })
    }

    function setRoutersDistance(position, routers) {
      if (!position || !position.latitude || !position.longitude) return
      var routersFiltered = getRoutersWithCoordinates(routers)
      routersFiltered.forEach(function (router) {
        var routerPosition = router.geolocalization.coordinates;
        router._distanceToUser = geolocationFactory.getDistance(routerPosition[0], routerPosition[1], position.latitude, position.longitude)
      });
      $scope.routersDistanceReady = true;
      if (!$scope.$$phase) $scope.$apply();
    }

    function getRoutersWithCoordinates(routers) {
      if (!routers) return []
      return routers.filter(function (router) {
        if (!router.geolocalization || !router.geolocalization.coordinates) return;
        if (!router.geolocalization.coordinates[0] || !router.geolocalization.coordinates[1]) return;
        var lat = router.geolocalization.coordinates[0];
        var lng = router.geolocalization.coordinates[1];
        if (!(lat > -90 && lat < 90) || !(lng > -180 && lng < 180)) return;
        return true;
      })
    }

    function filterRoutersByDistance(routers) {
      return new Promise(function (resolve, reject) {
        if (!$scope.maxRouterDistance) return resolve(routers)
        if (turnToModify) {
          var turnRouter = routers.find(function (router) { return router._id === turnToModify.router })
          return resolve(filterFromRouterPosition(turnRouter, routers))
        }
        getUserPosition(routers)
          .then(function (userPosition) {
            setRoutersDistance(userPosition, routers);
            var limitedRouters = routers.filter(function (router) {
              return router._distanceToUser < $scope.maxRouterDistance
            })
            $scope.userPosition = userPosition
            resolve(limitedRouters)
          })
          .catch(function () {
            resolve(routers)
          })
      })
    }

    function filterFromRouterPosition(router, routers) {
      setRoutersDistance({ latitude: router.geolocalization.coordinates[0], longitude: router.geolocalization.coordinates[1] }, routers)
      var limitedRouters = routers.filter(function (router) {
        return router._distanceToUser < $scope.maxRouterDistance
      })
      return limitedRouters
    }

    // Esta función intenta obtener la posición por GPS y si no lo consigue la pregunta manualmente en un popup.
    function getUserPosition(routers) {

      return $q(function (resolve, reject) {
        // Busca ubicación por GPS
        geolocationFactory.getCurrentPosition(
          function (userPosition) {
            resolve(userPosition)
          },
          function () { // Error callback
            geolocationFactory.estimatePosition()
              .then(function (estimatedPosition) {
                askForPosition(estimatedPosition, routers).then(resolve).catch(reject)
              })
              .catch(function () {
                askForPosition(null, routers).then(resolve).catch(reject)
              })
          })
      })

    }

    function askForPosition(estimated, routers) {
      return $q(function (resolve, reject) {
        if (!estimated) estimated = routersPositionAverage(routers)
        manualGeolocationModal.open({ latitude: estimated.latitude, longitude: estimated.longitude, routers: routers })
          .then(function (position) {
            $scope.badPrecision = true
            resolve(position)
          })
          .catch(function (error) { reject(error) })
      })
    }

    function routersPositionAverage(routers) {
      if (!routers) return { latitude: -34.60557434961402, longitude: -58.38013836941472 }
      var filteredRouters = getRoutersWithCoordinates(routers)
      var positionSum = filteredRouters.reduce(function (acc, router) {
        acc.latitude += router.geolocalization.coordinates[0]
        acc.longitude += router.geolocalization.coordinates[1]
        return acc
      }, { latitude: 0, longitude: 0 })
      return {
        latitude: positionSum.latitude / filteredRouters.length,
        longitude: positionSum.longitude / filteredRouters.length,
      }
    }

    function limitRoutersOnManualPosition(routers, previousPosition) {
      askForPosition(previousPosition, routers)
        .then(function (userPosition) {
          if (!userPosition) return
          setRoutersDistance(userPosition, routers)
          var limitedRouters = routers.filter(function (router) {
            return router._distanceToUser < $scope.maxRouterDistance
          })
          displayLocation(userPosition.latitude, userPosition.longitude).then(function (humanizedPosition) {
            $scope.humanizedPosition = humanizedPosition
          }).catch(function (err) { throw new PentaError(err) })
          $scope.userPosition = userPosition
          if (limitedRouters.length) $scope.outOfRange = false;
          $scope.routers = limitedRouters
          allRouters = limitedRouters
        })
        .catch(function (err) { if (err) throw new PentaError(err) })
    }

    function displayLocation(latitude, longitude) {
      return $q(function (resolve, reject) {
        if (!latitude || !longitude) reject(i18next.t('La ubicación otorgada es inválida.'))
        var geocoder;
        geocoder = new google.maps.Geocoder();
        var latlng = new google.maps.LatLng(latitude, longitude);

        geocoder.geocode(
          { 'latLng': latlng },
          function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                var add = results[0].formatted_address;
                resolve(add)
              }
              else {
                reject(i18next.t('Ubicación no conseguida'));
              }
            }
            else {
              reject(i18next.t('La localización falló. Estado: ') + status)
            }
          }
        );
      })
    }

    function getAdditionalInformationBackup() {
      var additionalInformationBackUp = appStorage.get("additionalInformationBackUp");
      if (additionalInformationBackUp) {
        try { additionalInformationBackUp = JSON.parse(additionalInformationBackUp); } catch (error) { additionalInformationBackUp = {}; }
      } else additionalInformationBackUp = {};
      return additionalInformationBackUp;
    }

    function applyAdditionalInformationBackUp(additionalInformations) {
      if (!additionalInformations || !additionalInformations.length) return;
      var additionalInformationBackUp = getAdditionalInformationBackup();
      additionalInformations.forEach(function (f) {
        f.value = additionalInformationBackUp[f._id];
      })
    }

    function setAdditionalInformationFromProfile(additionalInformation) {
      if (!additionalInformation || !additionalInformation._id) return
      var aiProfile = additionalInformationProfile.find(function (f) { return f._id === additionalInformation._id });
      if (aiProfile) additionalInformation.value = aiProfile.value;
    }

    async function dateToAvailability() {
      removeWaitingListFromSteper()
      $scope.onWaitingList = false
      if (!$scope.selectedDate) throw new PentaError('No se especifico fecha para calcular la fecha habilitada')
      let result = $scope.availability.find(function (f) { return f.date.toString() === changeUTC($scope.selectedDate, moment().format('Z').replace(':', ''), $scope.selectedRouter.utcOffset).toString() })
      if (!result) throw new PentaError('La fecha seleccionada no se encontró en las fechas habilitadas')
      if (result.isFullDay && $scope.selectedQueue?.activeWaitingList) await processWaitingList(result)
      else {
        return await nextStep(result);
      }
    }

    async function processWaitingList(availability) {
      addWaitingListFromSteper()
      let selectedDate = moment(changeUTC($scope.selectedDate, moment().format('Z').replace(':', ''), $scope.selectedRouter.utcOffset)).startOf('day').valueOf()
      let waitingList = $scope.myWaitingList.find(f => {
        if (!f.date || !f.queue || !f.router) return false
        let date = moment(changeUTC(f.date, moment().format('Z').replace(':', ''), $scope.selectedRouter.utcOffset)).startOf('day').valueOf()
        // Tiene que ser para la misma fecha, la misma sucursal y el mismo motivo
        return date === selectedDate && f.router === $scope.selectedRouter?._id && f.queue === $scope.selectedQueue?._id
      })
      let data = await noTurnsAvailableModal.open({ waitingList: waitingList }).catch(function (error) { console.log(error) });
      if (!data && $scope.selectedDate) return $scope.selectedDate = undefined
      if (data) {
        await nextStep(availability, 'day');
        await setStep('waitingList');
      }
    }

    function addWaitingListFromSteper() {
      if (steps.some(f => f === 'waitingList')) return
      steps.push('waitingList');
    }

    function removeWaitingListFromSteper() {
      let index = steps.findIndex(f => f === 'waitingList')
      if (index !== -1) steps.splice(index, 1);
    }

    async function getMyWaitingList() {
      try {
        if ($scope.myWaitingList.length) return // Si ya llene mi lista de espera no la obtengo nuevamente
        $scope.myWaitingList = await waitingListResource.query({ _select: ['router', 'queue', 'date'] }).$promise
        $scope.$applyAsync();
      }
      catch (err) { $scope.$applyAsync(() => { throw err }); }
    }

    function nodeMatchesSearch(term) {
      const searchText = term && term.trim().toLowerCase();
      if (!searchText) {
        $scope.visibleQueueTree = $scope.queueTree || [];
        return;
      }
      $scope.visibleQueueTree = searchInTree($scope.queueTree || [], searchText);
    }

    function searchInTree(queueTree, term) {
      const result = [];
      for (const queue of queueTree) {
        const currentQueue = (queue.name || '').toLowerCase().includes(term);
        const queueChildren = queue.nodes?.length ? searchInTree(queue.nodes, term) : [];

        if (currentQueue) {
          result.push(queue);
        } else if (queueChildren.length) {
          result.push({ ...queue, nodes: queueChildren, _hide: true });
        }
      }
      return result;
    }

    function changeUTC(date, from, to) {
      if (!date || !from || !to) return
      if (!date.utcOffset) date = moment(date)
      if (date._isValid)
        return date.utcOffset(from).utcOffset(to, true).toDate()
    }

    function canInmediate(availability, reservation, router) {
      // Si bien no hay configuracion de disponibilidad o el primer dia configurado no es para hoy 
      // entonces quiere decir que hoy no se atiende (no hay configurado siquiera disponibilidad)
      if (!availability?.length || !router?.utcOffset)
        return {
          isCanInmediate: false,
          errorTitle: i18next.t('En este momento no estamos atendiendo.'),
          errorMessage: i18next.t('Inténtelo de nuevo dentro del horario de atención.')
        }
      const now = moment().utcOffset(router.utcOffset)
      const startOfDay = now.clone().utcOffset(router.utcOffset).set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
      const availabilityDay = availability[0]
      reservation.date = now
      // Si el primer dia disponible es distinto a hoy, devuelve un error de no estamos atendiendo
      if (!startOfDay.isSame(availabilityDay.date)) {
        return {
          isCanInmediate: false,
          errorTitle: i18next.t('En este momento no estamos atendiendo.'),
          errorMessage: i18next.t('Inténtelo de nuevo dentro del horario de atención.')
        }
        // Si no tengo disponibilidad ahora mismo, devuelve un error de nuestros agentes están ocupados
      } else if (!availabilityRightNow(now, availabilityDay)) {
        return {
          isCanInmediate: false,
          errorTitle: i18next.t('En este momento todos nuestros agentes están ocupados.'),
          errorMessage: i18next.t('Inténtelo nuevamente más tarde.')
        }
      } else return {
        isCanInmediate: true,
        errorTitle: null,
        errorMessage: null
      }
    }

    //- Esta function devuelve true/false si hay disponibilidad ahora.
    function availabilityRightNow(now, availabilityDay) {
      if (!now || !availabilityDay) return false
      if (availabilityDay.isFullDay) return false
      if (!availabilityDay.hours?.length) return false

      const nowAvailability = availabilityDay.hours.find(f => {
        return now.isBetween(moment(f.start), moment(f.end))
      })
      if (!nowAvailability) return false

      return true
    }
  }
})();

